import React, { Component } from 'react'
import {Grid,Row,Col,Image} from "react-bootstrap"
import "./News.css"

export default class News extends Component {
  render() {
    return (
      <div>
          <Image src="assets/mountain-man.jpg" className="header-image"/>
          <Grid>
              <h2>News</h2>
              <Row>
                <Col xs={12} sm={8} className="main-section">
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. In, vitae corrupti. Repellat provident nulla quidem?
                   Voluptatibus ipsum autem nobis ratione. Distinctio nesciunt veniam tempora
                   harum dolores maxime iste, adipisci autem?
                 </p>
                
                 <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. In, vitae corrupti. Repellat provident nulla quidem?
                   Voluptatibus ipsum autem nobis ratione. Distinctio nesciunt veniam tempora
                   harum dolores maxime iste, adipisci autem?
                 </p>

                 <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. In, vitae corrupti. Repellat provident nulla quidem?
                   Voluptatibus ipsum autem nobis ratione. Distinctio nesciunt veniam tempora
                   harum dolores maxime iste, adipisci autem?
                 </p>

                 <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. In, vitae corrupti. Repellat provident nulla quidem?
                   Voluptatibus ipsum autem nobis ratione. Distinctio nesciunt veniam tempora
                   harum dolores maxime iste, adipisci autem?
                 </p>

                 <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. In, vitae corrupti. Repellat provident nulla quidem?
                   Voluptatibus ipsum autem nobis ratione. Distinctio nesciunt veniam tempora
                   harum dolores maxime iste, adipisci autem?
                 </p>

                </Col>
                <Col xs={12} sm={4} className="sidebar-section">
                  <Image src="assets/dog-people.jpg" />

                  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. In, vitae corrupti. Repellat provident nulla quidem?
                   Voluptatibus ipsum autem nobis ratione. Distinctio nesciunt veniam tempora
                   harum dolores maxime iste, adipisci autem?
                 </p>
                
                </Col>


              </Row>

          </Grid>

        
      </div>
    )
  }
}
